import { DailyProductionProcessRoles } from '@app/models/roles/roles-group';

/**
 * Processes the Daily Production report can be filtered by.
 *
 * The values are the process keys the Production API expects in the `processes`
 * query param, and they must stay in sync with `ProcessKeys` (Sierra.Finance.Models)
 * plus the two Finished Goods pseudo-processes defined in `DailyProductionAreaCatalog`.
 */
export enum DailyProductionProcess {
  Knitting = 'Knitting',
  Greige = 'Greige',
  Batching = 'Batching',
  Dyeing = 'Dyeing',
  Finishing = 'Finishing',
  Rolling = 'Rolling',
  FinishedGoodsInbound = 'FinishedGoods',
  FinishedGoodsOutbound = 'FinishedGoodsOut',
}

/** Report order, matching the order of the sheets in the generated workbook. */
export const DAILY_PRODUCTION_PROCESSES: readonly DailyProductionProcess[] = [
  DailyProductionProcess.Knitting,
  DailyProductionProcess.Greige,
  DailyProductionProcess.Batching,
  DailyProductionProcess.Dyeing,
  DailyProductionProcess.Finishing,
  DailyProductionProcess.Rolling,
  DailyProductionProcess.FinishedGoodsInbound,
  DailyProductionProcess.FinishedGoodsOutbound,
];

/**
 * Role required to download each process. Both Finished Goods directions share a single
 * role, so granting it gives inbound and outbound together.
 */
export const DAILY_PRODUCTION_PROCESS_ROLES: Readonly<Record<DailyProductionProcess, DailyProductionProcessRoles>> = {
  [DailyProductionProcess.Knitting]: DailyProductionProcessRoles.DailyProductionKnittingViewer,
  [DailyProductionProcess.Greige]: DailyProductionProcessRoles.DailyProductionGreigeViewer,
  [DailyProductionProcess.Batching]: DailyProductionProcessRoles.DailyProductionBatchingViewer,
  [DailyProductionProcess.Dyeing]: DailyProductionProcessRoles.DailyProductionDyeingViewer,
  [DailyProductionProcess.Finishing]: DailyProductionProcessRoles.DailyProductionFinishingViewer,
  [DailyProductionProcess.Rolling]: DailyProductionProcessRoles.DailyProductionRollingViewer,
  [DailyProductionProcess.FinishedGoodsInbound]: DailyProductionProcessRoles.DailyProductionFinishedGoodsViewer,
  [DailyProductionProcess.FinishedGoodsOutbound]: DailyProductionProcessRoles.DailyProductionFinishedGoodsViewer,
};
